import { Box } from '@mui/material';
import BBModal from './BBModal';

const ViewImageModal = ({ open, onClose, title, img, alt = 'selected-img' }) => {
  return (
    <BBModal
      title={title}
      size="md"
      openModal={open}
      cancelEvent={onClose}
      cancelText="Close"
      useOneButton
      modalBodyContent={
        <Box width={1}>
          <img src={img} alt={alt} style={{ width: '100%' }} />
        </Box>
      }
    />
  );
};

export default ViewImageModal;
